export default __webpack_public_path__ + "static/media/Ecuatorianoblc.236b5e61.svg";